export const tenorMaster =  [
    {
        "id": 1,
        "tenor_days": 5,
        "soft_tenor_days": 10,
        "cooling_period_days": 15,
        "light_overdue_days": 20,
        "interest_tenor_days": 25,
        "fee_tenor_days": 30
    },
    {
        "id": 3,
        "tenor_days": 7,
        "soft_tenor_days": 14,
        "cooling_period_days": 21,
        "light_overdue_days": 28,
        "interest_tenor_days": 35,
        "fee_tenor_days": 42
    },
    {
        "id": 2,
        "tenor_days": 10,
        "soft_tenor_days": 20,
        "cooling_period_days": 30,
        "light_overdue_days": 40,
        "interest_tenor_days": 50,
        "fee_tenor_days": 60
    }
];